import { createSelector } from '@reduxjs/toolkit';
import type { AppState } from 'admin/src/store';

const selectCoursesSlice = (state: AppState) => state.pollworker.courses;

export const selectCourses = createSelector(selectCoursesSlice, (s) => s.courses);

export const selectReadiness = createSelector(selectCoursesSlice, (s) => s.readiness);

export const selectCoursesLoading = createSelector(selectCoursesSlice, (s) => s.loading);

export const selectCoursesError = createSelector(selectCoursesSlice, (s) => s.error);

export const selectSelectedCourseId = createSelector(selectCoursesSlice, (s) => s.selectedCourseId);

export const selectCourseDetail = createSelector(selectCoursesSlice, (s) => s.courseDetail);

export const selectCoursesSelectedSessionId = createSelector(selectCoursesSlice, (s) => s.selectedSessionId);

export const selectSelectedSession = createSelector(selectCoursesSlice, (s) => s.selectedSession);

export const selectCoursesLoadingSession = createSelector(selectCoursesSlice, (s) => s.loadingSession);

export const selectElectionIds = createSelector(selectCoursesSlice, (s) => s.electionIds);

export const selectRoleIds = createSelector(selectCoursesSlice, (s) => s.roleIds);

export const selectFilterCourseIds = createSelector(selectCoursesSlice, (s) => s.filterCourseIds);

export const selectFilterSessionIds = createSelector(selectCoursesSlice, (s) => s.filterSessionIds);

export const selectAllSessions = createSelector(selectCourses, (courses) =>
  courses.flatMap((course) =>
    course.sessions.map((s) => ({
      ...s,
      courseId: course.id,
      courseName: course.className,
    })),
  ),
);

export const selectSelectedCourseSessionCount = createSelector([selectCourses, selectSelectedCourseId], (courses, selectedCourseId) => {
  if (!selectedCourseId) return 0;
  const course = courses.find((c) => c.id === selectedCourseId);
  return course?.sessionCount ?? 0;
});
